export default __webpack_public_path__ + "static/media/quick-action.62bbdb9c.svg";